import { render } from "./NewPaymentPage.vue?vue&type=template&id=51dd6355"
import script from "./NewPaymentPage.vue?vue&type=script&lang=js"
export * from "./NewPaymentPage.vue?vue&type=script&lang=js"

import "./NewPaymentPage.vue?vue&type=style&index=0&id=51dd6355&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__